import { render, staticRenderFns } from "./router.vue?vue&type=template&id=46f8aee2&scoped=true"
import script from "./router.vue?vue&type=script&lang=js"
export * from "./router.vue?vue&type=script&lang=js"
import style0 from "./router.vue?vue&type=style&index=0&id=46f8aee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f8aee2",
  null
  
)

export default component.exports